export default __webpack_public_path__ + "static/media/wave.ef858604.webp";